<template>
  <div class="tut-taget-item">
    <div class="sample lang-grd-mic">
      <h4>{{ t('language_meta') }}</h4>
    </div>
    <span>{{ t('single_language_home') }}</span>
  </div>
</template>
<script setup lang="ts">
const { t } = useI18n();
</script>
<style scoped lang="scss">
.tut-taget-item {
  background: var(--surface-overlay);
  border: 2px solid $color-navy-50;
  border-radius: $size-s;
  width: auto;
  max-width: 100px;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
  white-space: nowrap;

  .lang-grd-mic {
    background-color: $primary-bg;
    height: 3rem;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: $size-s;
    h4 {
      background: var(--font-gradient-language);
      -webkit-text-fill-color: transparent;
      background-clip: text;
      -webkit-background-clip: text;
      font-size: 1rem;
      font-weight: 600;
      white-space: nowrap;
    }
  }
  span {
    font-size: $font-size-psmall;
    font-weight: 500;
    color: $color-gray-200;
  }
}
</style>
